import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";

import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import MobileBottomNav from "@/components/layout/MobileBottomNav";
import FloatingActions from "@/components/FloatingActions";
import ProtectedRoute from "@/components/ProtectedRoute";
import ScrollToTop from "@/components/ScrollToTop";
import TawkChat from "@/components/TawkChat";

import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Sell from "@/pages/Sell";
import Dashboard from "@/pages/Dashboard";
import TransactionDetail from "@/pages/TransactionDetail";
import Admin from "@/pages/Admin";
import Rates from "@/pages/Rates";
import ProofOfPayments from "@/pages/ProofOfPayments";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import FAQ from "@/pages/FAQ";
import BrandLanding from "@/pages/BrandLanding";
import CountryLanding from "@/pages/CountryLanding";
import BrandsHub from "@/pages/BrandsHub";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <div className="App flex flex-col min-h-screen bg-white">
            <Navbar />
            <main className="flex-1 pb-20 md:pb-0">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route
                  path="/sell"
                  element={
                    <ProtectedRoute>
                      <Sell />
                    </ProtectedRoute>
                  }
                />
                <Route path="/sell/:slug" element={<BrandLanding />} />
                <Route path="/sell-in/:code" element={<CountryLanding />} />
                <Route path="/brands" element={<BrandsHub />} />
                <Route path="/rates" element={<Rates />} />
                <Route path="/proof" element={<ProofOfPayments />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route
                  path="/dashboard"
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/transactions/:tx_id"
                  element={
                    <ProtectedRoute>
                      <TransactionDetail />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute adminOnly>
                      <Admin />
                    </ProtectedRoute>
                  }
                />
                <Route path="*" element={<Home />} />
              </Routes>
            </main>
            <Footer />
            <MobileBottomNav />
            <FloatingActions />
            <TawkChat />
            <Toaster position="top-right" richColors closeButton />
          </div>
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
